import useLazyRef from './useLazyRef';

/**
 * @category Hooks
 *
 * Will create a unique id to be used during the whole component lifecycle.
 * It'll persist renders, but it will be a new id if the component is unmounted and mounted.
 * @return {string} Unique ID that persists between renders.
 */

export default function useUniqueId() {
  return useLazyRef(() => Math.random().toString(36).slice(2)).current;
}